


















































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import CustomMap from '@/components/CustomMap.vue'
import {IRole} from '@/store/modules/views/role/states'
import {IUser} from '@/store/modules/views/user/states'
import { ICenter } from '@/store/modules/views/center/states'

@Component({
  components: { CustomMap },
})
export default class EditStaffDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private getList!: () => Promise<void>
  @Prop() private user!: IUser & {permissions: string[], accounts: string[], metadate: string[]}
  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }

  private optionUser = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private valid = false
  private role: Partial<IRole> = {}
  private centerId = ''
  private name = ''

  private loading = false
  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get isDisabledCenter() {
    return !(this.role && this.role.requireCenter)
  }

  @Getter('center/centerLists')
  private centerItemLists!: ICenter[]

  get openDialog() {
    return this.open
  }

  @Getter('user/userLists')
  private userItemLists!: IUser[]

  @Getter('role/roleLists')
  private roleItemLists!: IRole[]

  @Action('user/getUserListByRoleId')
  private getUserList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
    id: string,
  }) => void

  // tslint:disable-next-line:adjacent-overload-signatures
  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  public async created() {
    this.name = `${this.user.prefix || ''}${this.user.firstname} ${this.user.lastname}`
    this.role = _.find(this.roleItemLists, (role) => role._id === this.user.roleId)
    this.centerId = this.user.centerId || ''
  }

  get centerLists() {
    return this.centerItemLists
  }

  get editLeaderDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editLeaderAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get invalidateInput() {
    return _.some(
        [],
        (item) => item !== true,
    )
  }

  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private async editLeaderAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      try {
        await HttpRequestServiceWithToken.putByLevel(
          `${process.env.VUE_APP_API_URL}/v1`,
          `user/${this.user._id}/role/${this.role._id}`, {centerId: this.centerId},
        )
        this.updateSnackbar({txt: 'บันทึกเจ้าหน้าที่สำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
      }
    } else {
      return false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
